export default (func, keyOnly = true) =>
	(_, value) =>
		func(keyOnly ? value?.key : value);
